import { SparePart } from '../models/spare-part.interface';

export interface SparePartsState {
  parts: SparePart | null;
}

export const initialState: SparePartsState = { parts: null };
